export default "__VITE_ASSET__DNlDPbDU__"